module.exports = __webpack_public_path__ + "static/media/mobile.4c634a2f.png";